import { Component, Input } from '@angular/core';
import {
  AbstractWorkspaceHostComponent,
  AbstractWorkspaceInputs,
} from '../../shared/abstract-workspace-host.component';
import { Project } from '../../team-apis/otterdam/project';
import { PreviewWorkspaceComponent } from './preview-workspace.component';

const previewWorkspaceInputKeys = [
  'project',
  'stepId',
  'layout',
  'jsCode',
] as const;

export type PreviewWorkspaceInputs = Pick<
  PreviewWorkspaceComponent,
  (typeof previewWorkspaceInputKeys)[number]
> &
  AbstractWorkspaceInputs;

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- no loading state with on push
@Component({
  selector: 'h3-preview-workspace-host',
  templateUrl: '../../shared/abstract-workspace-host.component.html',
  standalone: false,
})
export class PreviewWorkspaceHostComponent
  extends AbstractWorkspaceHostComponent<PreviewWorkspaceComponent>
  implements PreviewWorkspaceInputs
{
  @Input({ required: true }) project!: Project;
  @Input({ required: true }) stepId!: number;
  @Input({ required: true }) layout!: string;
  @Input({ required: true }) jsCode!: string;

  constructor() {
    super(PreviewWorkspaceComponent, previewWorkspaceInputKeys);
  }

  protected override getProjectId() {
    return this.project.id;
  }
}
